import {ReactElement} from 'react'
import { NavLink } from "react-router-dom";
import './NavBar.scss'
import {useDivisionOrUndefined} from "./shared"

function activeClass({isActive}: {isActive: boolean}) : string {
  return isActive ? 'active' : 'inactive'
}

type Props = {
  nrErrorsAndWarnings: [number, number] | undefined,
}

export function NavBar({nrErrorsAndWarnings}: Props): ReactElement {
  const division = useDivisionOrUndefined()
  function getURL(path: string) {
    if (division === undefined) {
      return ""
    }
    return "/division/" + division.toString() + path
  }
  const NAV: readonly [string, string, string, boolean][] = [
    ["home", "/", "Home", true],
    ["po-editor", "/POEditor", "PO Editor", false],
    ["pas-overview", "/PASOverview", "PAS Overview", false],
    ["pas-detailed", "/PASDetailed", "PAS Detailed", false],
    ["scenarios", "/Scenarios", "Scenarios", false],
    ["so-tool", "/SOTool", "SO Tool", false],
    ["lists", "/Lists", "Lists", false],
  ]
  const EWclassName = [
    "nrErrorsAndWarnings nrErrors",
    "nrErrorsAndWarnings nrWarnings",
  ]
  return  (
    <ul id="navbar">
      {NAV.map(([cy_id, base_url, label, useErrorAndWarningCount]) =>
        <li key={cy_id} data-cy={`navbar-${cy_id}`}>
          <NavLink className={activeClass} to={getURL(base_url)}>
            {label}
            {useErrorAndWarningCount && nrErrorsAndWarnings !== undefined &&
              nrErrorsAndWarnings.map((cnt, i) => (
                !!cnt && <span key={i} className={EWclassName[i]}>{cnt}</span>
            ))}
          </NavLink>
        </li>)
      }
  </ul>
  )
}
